export const characterLookup: {[key: string]: string} ={
    "https://ipfs.io/ipfs/QmTDNYRLZWK42WZdfji5Z6x28rpwK38n94y7m5BhTNkC3P?filename=avatar.gif": "avatar",
    "https://ipfs.io/ipfs/QmVBXSzghXZvJHYDAEhycneJDnosDwCsmoS5x6QL323Y9C?filename=bluesword.gif": "bluesword",
    "https://ipfs.io/ipfs/QmQFqsBXxRxFsT5fjQVxjvPAH8PWe8cDQaEWDs96CAJVVL?filename=brutal.gif": "brutal",
    "https://ipfs.io/ipfs/QmSJT8Ni7LgEU8dg3rFSzWZcSnVTfF46dX6BvuirNyewvM?filename=greenlizard.gif": "greenlizard",
    "https://ipfs.io/ipfs/QmWtWpBTRiVYNMGHH52RzHwTSWoFVRpho5wanbBpkCLHEp?filename=heavybot.gif": "heavybot",
    "https://ipfs.io/ipfs/QmWgkotHn6CiDkp8ebbLazTA9m5XaucisBX2SZ27tvbGTg?filename=hecto.gif": "hecto",
    "https://ipfs.io/ipfs/QmVoZ9AguLbfi4hYvoaNGwMoDHzPbx9gPUxfppe44B4vNS?filename=jumblo.gif": "jumblo",
    "https://ipfs.io/ipfs/QmWjaNh4kQ8wCqgujZEGvXVJgw5J6ruhYUFWSYZyx21byG?filename=monkey.gif": "monkey",
    "https://ipfs.io/ipfs/QmRm1wafa7Rv5TfRZEThJBPsfQorGyoAR8wNXzxWTiBFU3?filename=redflame.gif": "redflame"
};
